/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Feature_7_TitleInputs */

const en_mk_feature_7_title = /** @type {(inputs: Mk_Feature_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus & facilitators`)
};

const id_mk_feature_7_title = /** @type {(inputs: Mk_Feature_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampus & fasilitator`)
};

/**
* | output |
* | --- |
* | "Campus & facilitators" |
*
* @param {Mk_Feature_7_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_feature_7_title = /** @type {((inputs?: Mk_Feature_7_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Feature_7_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_feature_7_title(inputs)
	return en_mk_feature_7_title(inputs)
});